<template>
  <footer>
    <PageFooterLocal />
    <PageFooterGlobal />
  </footer>
</template>
